// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  gap: 12px;
}

.date-advice-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: start;
  gap: 12px;
}

.date-advice-row .flex-field {
  max-width: 200px;
}

.policy-advice-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  align-items: center;
  gap: 16px;
  width: 100%;
}

.flex-field {
  flex: 1;
}

.btn {
  border-radius: 24px;
  background: linear-gradient(90deg, #ed845d 0%, #da522f 100%);
  color: #ffffff;
}

.advice-container {
  display: flex;
  padding: 4px 10px 6px 10px;
  border: 1px dashed #999999;
  border-radius: 8px;
  background-color: #ffffff;
  width: -moz-fit-content;
  width: fit-content;
  min-width: 260px;
  cursor: pointer;
  position: relative;
}

.advice-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.advice-content {
  display: flex;
  flex-direction: column;
}

.advice-title {
  font-size: 14px;
  font-weight: 400;
  color: #1c1c1c;
}

.advice-title .asterisk {
  color: #da5330;
}

.advice-subtitle {
  font-size: 12px;
  font-weight: 400;
  color: #a3a3a3;
}

.advice-filename {
  font-size: 12px;
  font-weight: 400;
  text-decoration: underline;
  color: #1c1c1c;
}

.advice-close-btn {
  margin-left: auto;
}

.advice-close-btn {
  display: flex;
  align-items: flex-end;
  border: none;
  background: transparent;
}

.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 0;
  background: rgba(255, 255, 255, 0.9);
  margin: 20px 0;
}

.loading-text {
  margin-top: 24px;
  font-size: 16px;
  font-weight: 500;
  color: #1c1c1c;
  animation: text-pulse 1.8s ease-in-out infinite;
}

::ng-deep .mat-dialog-container {
  border-radius: 16px !important;
  padding: 16px !important;
}

:host ::ng-deep * {
  font-family: "Roboto", sans-serif !important;
}

h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #1c1c1c;
  font-family: "Roboto", sans-serif !important;
}

.verify-btn {
  background: linear-gradient(90deg, #00b2ff 0%, #1288ff 100%) !important;
  color: white !important;
  border-radius: 24px !important;
  font-size: 14px;
  font-weight: 600;
  padding: 6px 12px !important;
  border: none;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNhcmVwbHVzLXBheW1lbnQtY2hlY2tvdXQuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGFBQWE7RUFDYixpQkFBaUI7RUFDakIsdUJBQXVCO0VBQ3ZCLFNBQVM7QUFDWDs7QUFFQTtFQUNFLGFBQWE7RUFDYixpQkFBaUI7RUFDakIsa0JBQWtCO0VBQ2xCLFNBQVM7QUFDWDs7QUFFQTtFQUNFLGdCQUFnQjtBQUNsQjs7QUFFQTtFQUNFLGFBQWE7RUFDYixnREFBZ0Q7RUFDaEQsbUJBQW1CO0VBQ25CLFNBQVM7RUFDVCxXQUFXO0FBQ2I7O0FBRUE7RUFDRSxPQUFPO0FBQ1Q7O0FBRUE7RUFDRSxtQkFBbUI7RUFDbkIsNERBQTREO0VBQzVELGNBQWM7QUFDaEI7O0FBRUE7RUFDRSxhQUFhO0VBQ2IsMEJBQTBCO0VBQzFCLDBCQUEwQjtFQUMxQixrQkFBa0I7RUFDbEIseUJBQXlCO0VBQ3pCLHVCQUFrQjtFQUFsQixrQkFBa0I7RUFDbEIsZ0JBQWdCO0VBQ2hCLGVBQWU7RUFDZixrQkFBa0I7QUFDcEI7O0FBRUE7RUFDRSxhQUFhO0VBQ2IsbUJBQW1CO0VBQ25CLHVCQUF1QjtFQUN2QixrQkFBa0I7QUFDcEI7O0FBRUE7RUFDRSxhQUFhO0VBQ2Isc0JBQXNCO0FBQ3hCOztBQUVBO0VBQ0UsZUFBZTtFQUNmLGdCQUFnQjtFQUNoQixjQUFjO0FBQ2hCOztBQUVBO0VBQ0UsY0FBYztBQUNoQjs7QUFFQTtFQUNFLGVBQWU7RUFDZixnQkFBZ0I7RUFDaEIsY0FBYztBQUNoQjs7QUFFQTtFQUNFLGVBQWU7RUFDZixnQkFBZ0I7RUFDaEIsMEJBQTBCO0VBQzFCLGNBQWM7QUFDaEI7O0FBRUE7RUFDRSxpQkFBaUI7QUFDbkI7O0FBRUE7RUFDRSxhQUFhO0VBQ2IscUJBQXFCO0VBQ3JCLFlBQVk7RUFDWix1QkFBdUI7QUFDekI7O0FBRUE7RUFDRSxhQUFhO0VBQ2Isc0JBQXNCO0VBQ3RCLG1CQUFtQjtFQUNuQix1QkFBdUI7RUFDdkIsZUFBZTtFQUNmLG9DQUFvQztFQUNwQyxjQUFjO0FBQ2hCOztBQUVBO0VBQ0UsZ0JBQWdCO0VBQ2hCLGVBQWU7RUFDZixnQkFBZ0I7RUFDaEIsY0FBYztFQUNkLCtDQUErQztBQUNqRDs7QUFFQTtFQUNFLDhCQUE4QjtFQUM5Qix3QkFBd0I7QUFDMUI7O0FBRUE7RUFDRSw0Q0FBNEM7QUFDOUM7O0FBRUE7RUFDRSxTQUFTO0VBQ1QsZUFBZTtFQUNmLGdCQUFnQjtFQUNoQixjQUFjO0VBQ2QsNENBQTRDO0FBQzlDOztBQUVBO0VBQ0UsdUVBQXVFO0VBQ3ZFLHVCQUF1QjtFQUN2Qiw4QkFBOEI7RUFDOUIsZUFBZTtFQUNmLGdCQUFnQjtFQUNoQiw0QkFBNEI7RUFDNUIsWUFBWTtBQUNkIiwiZmlsZSI6ImNhcmVwbHVzLXBheW1lbnQtY2hlY2tvdXQuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5wYXltZW50LXJvdyB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtd3JhcDogbm93cmFwO1xuICBhbGlnbi1pdGVtczogZmxleC1zdGFydDtcbiAgZ2FwOiAxMnB4O1xufVxuXG4uZGF0ZS1hZHZpY2Utcm93IHtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC13cmFwOiBub3dyYXA7XG4gIGFsaWduLWl0ZW1zOiBzdGFydDtcbiAgZ2FwOiAxMnB4O1xufVxuXG4uZGF0ZS1hZHZpY2Utcm93IC5mbGV4LWZpZWxkIHtcbiAgbWF4LXdpZHRoOiAyMDBweDtcbn1cblxuLnBvbGljeS1hZHZpY2Utcm93IHtcbiAgZGlzcGxheTogZ3JpZDtcbiAgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiByZXBlYXQoMywgbWlubWF4KDAsIDFmcikpO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBnYXA6IDE2cHg7XG4gIHdpZHRoOiAxMDAlO1xufVxuXG4uZmxleC1maWVsZCB7XG4gIGZsZXg6IDE7XG59XG5cbi5idG4ge1xuICBib3JkZXItcmFkaXVzOiAyNHB4O1xuICBiYWNrZ3JvdW5kOiBsaW5lYXItZ3JhZGllbnQoOTBkZWcsICNlZDg0NWQgMCUsICNkYTUyMmYgMTAwJSk7XG4gIGNvbG9yOiAjZmZmZmZmO1xufVxuXG4uYWR2aWNlLWNvbnRhaW5lciB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIHBhZGRpbmc6IDRweCAxMHB4IDZweCAxMHB4O1xuICBib3JkZXI6IDFweCBkYXNoZWQgIzk5OTk5OTtcbiAgYm9yZGVyLXJhZGl1czogOHB4O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZmZmZmZmO1xuICB3aWR0aDogZml0LWNvbnRlbnQ7XG4gIG1pbi13aWR0aDogMjYwcHg7XG4gIGN1cnNvcjogcG9pbnRlcjtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xufVxuXG4uYWR2aWNlLWljb24td3JhcHBlciB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBtYXJnaW4tcmlnaHQ6IDEycHg7XG59XG5cbi5hZHZpY2UtY29udGVudCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG59XG5cbi5hZHZpY2UtdGl0bGUge1xuICBmb250LXNpemU6IDE0cHg7XG4gIGZvbnQtd2VpZ2h0OiA0MDA7XG4gIGNvbG9yOiAjMWMxYzFjO1xufVxuXG4uYWR2aWNlLXRpdGxlIC5hc3RlcmlzayB7XG4gIGNvbG9yOiAjZGE1MzMwO1xufVxuXG4uYWR2aWNlLXN1YnRpdGxlIHtcbiAgZm9udC1zaXplOiAxMnB4O1xuICBmb250LXdlaWdodDogNDAwO1xuICBjb2xvcjogI2EzYTNhMztcbn1cblxuLmFkdmljZS1maWxlbmFtZSB7XG4gIGZvbnQtc2l6ZTogMTJweDtcbiAgZm9udC13ZWlnaHQ6IDQwMDtcbiAgdGV4dC1kZWNvcmF0aW9uOiB1bmRlcmxpbmU7XG4gIGNvbG9yOiAjMWMxYzFjO1xufVxuXG4uYWR2aWNlLWNsb3NlLWJ0biB7XG4gIG1hcmdpbi1sZWZ0OiBhdXRvO1xufVxuXG4uYWR2aWNlLWNsb3NlLWJ0biB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBmbGV4LWVuZDtcbiAgYm9yZGVyOiBub25lO1xuICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudDtcbn1cblxuLmxvYWRlci1jb250YWluZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgcGFkZGluZzogODBweCAwO1xuICBiYWNrZ3JvdW5kOiByZ2JhKDI1NSwgMjU1LCAyNTUsIDAuOSk7XG4gIG1hcmdpbjogMjBweCAwO1xufVxuXG4ubG9hZGluZy10ZXh0IHtcbiAgbWFyZ2luLXRvcDogMjRweDtcbiAgZm9udC1zaXplOiAxNnB4O1xuICBmb250LXdlaWdodDogNTAwO1xuICBjb2xvcjogIzFjMWMxYztcbiAgYW5pbWF0aW9uOiB0ZXh0LXB1bHNlIDEuOHMgZWFzZS1pbi1vdXQgaW5maW5pdGU7XG59XG5cbjo6bmctZGVlcCAubWF0LWRpYWxvZy1jb250YWluZXIge1xuICBib3JkZXItcmFkaXVzOiAxNnB4ICFpbXBvcnRhbnQ7XG4gIHBhZGRpbmc6IDE2cHggIWltcG9ydGFudDtcbn1cblxuOmhvc3QgOjpuZy1kZWVwICoge1xuICBmb250LWZhbWlseTogXCJSb2JvdG9cIiwgc2Fucy1zZXJpZiAhaW1wb3J0YW50O1xufVxuXG5oMiB7XG4gIG1hcmdpbjogMDtcbiAgZm9udC1zaXplOiAyNHB4O1xuICBmb250LXdlaWdodDogNjAwO1xuICBjb2xvcjogIzFjMWMxYztcbiAgZm9udC1mYW1pbHk6IFwiUm9ib3RvXCIsIHNhbnMtc2VyaWYgIWltcG9ydGFudDtcbn1cblxuLnZlcmlmeS1idG4ge1xuICBiYWNrZ3JvdW5kOiBsaW5lYXItZ3JhZGllbnQoOTBkZWcsICMwMGIyZmYgMCUsICMxMjg4ZmYgMTAwJSkgIWltcG9ydGFudDtcbiAgY29sb3I6IHdoaXRlICFpbXBvcnRhbnQ7XG4gIGJvcmRlci1yYWRpdXM6IDI0cHggIWltcG9ydGFudDtcbiAgZm9udC1zaXplOiAxNHB4O1xuICBmb250LXdlaWdodDogNjAwO1xuICBwYWRkaW5nOiA2cHggMTJweCAhaW1wb3J0YW50O1xuICBib3JkZXI6IG5vbmU7XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/careplus/careplus-payment-checkout/careplus-payment-checkout.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,4DAA4D;EAC5D,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,uBAAkB;EAAlB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,uEAAuE;EACvE,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,YAAY;AACd;;AAGA,g6JAAg6J","sourcesContent":[".payment-row {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.date-advice-row {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: start;\n  gap: 12px;\n}\n\n.date-advice-row .flex-field {\n  max-width: 200px;\n}\n\n.policy-advice-row {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n}\n\n.flex-field {\n  flex: 1;\n}\n\n.btn {\n  border-radius: 24px;\n  background: linear-gradient(90deg, #ed845d 0%, #da522f 100%);\n  color: #ffffff;\n}\n\n.advice-container {\n  display: flex;\n  padding: 4px 10px 6px 10px;\n  border: 1px dashed #999999;\n  border-radius: 8px;\n  background-color: #ffffff;\n  width: fit-content;\n  min-width: 260px;\n  cursor: pointer;\n  position: relative;\n}\n\n.advice-icon-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 12px;\n}\n\n.advice-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.advice-title {\n  font-size: 14px;\n  font-weight: 400;\n  color: #1c1c1c;\n}\n\n.advice-title .asterisk {\n  color: #da5330;\n}\n\n.advice-subtitle {\n  font-size: 12px;\n  font-weight: 400;\n  color: #a3a3a3;\n}\n\n.advice-filename {\n  font-size: 12px;\n  font-weight: 400;\n  text-decoration: underline;\n  color: #1c1c1c;\n}\n\n.advice-close-btn {\n  margin-left: auto;\n}\n\n.advice-close-btn {\n  display: flex;\n  align-items: flex-end;\n  border: none;\n  background: transparent;\n}\n\n.loader-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 80px 0;\n  background: rgba(255, 255, 255, 0.9);\n  margin: 20px 0;\n}\n\n.loading-text {\n  margin-top: 24px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #1c1c1c;\n  animation: text-pulse 1.8s ease-in-out infinite;\n}\n\n::ng-deep .mat-dialog-container {\n  border-radius: 16px !important;\n  padding: 16px !important;\n}\n\n:host ::ng-deep * {\n  font-family: \"Roboto\", sans-serif !important;\n}\n\nh2 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  color: #1c1c1c;\n  font-family: \"Roboto\", sans-serif !important;\n}\n\n.verify-btn {\n  background: linear-gradient(90deg, #00b2ff 0%, #1288ff 100%) !important;\n  color: white !important;\n  border-radius: 24px !important;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 6px 12px !important;\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
